module.exports = __webpack_public_path__ + "static/media/1024293.fe630bca.jpg";